module.exports = __webpack_public_path__ + "static/media/ig.bfbdcd59.png";